export function parseAuthorities(token: string): string[] {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const raw: Array<{ authority: string }> = payload.authorities ?? [];
        return raw.map((a) => a.authority);
    } catch {
        return [];
    }
}

/** The user's default store id from the JWT (`defaultStoreId` claim), or null. */
export function parseStoreId(token: string): string | null {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const id = payload.defaultStoreId;
        return id ? String(id) : null;
    } catch {
        return null;
    }
}
